/**
 * Extract the filename from a `Content-Disposition` header value.
 * Note: preserves the original behaviour of throwing when the header contains
 * no `filename=` token (the regex match returns null).
 */
export const fileNameFromContentDisposition = (contentDisposition: string): string => {
    const re = /filename?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/g;
    return (contentDisposition.match(re) as RegExpMatchArray)[0].split('=')[1].slice(0, -1) ?? '';
};
